import yup from 'plugins/yup-config';

const prepareSelectField = (options = []) => {
  if (!Array.isArray(options)) return [];

  return options.map((option) => ({
    value: option,
    label: option,
  }));
};

const isFieldWithObjValueFilled = (value) => {
  return !value?.label ? null : value;
};

const normalizeTextFieldValue = (value) => {
  if (value === null || value === undefined) return '';
  if (typeof value === 'string') return value;
  if (typeof value === 'number') {
    return Number.isNaN(value) ? '' : String(value);
  }
  if (typeof value === 'object' && 'label' in value) return value.label || '';
  return '';
};

const validateTimeFormat = () =>
  yup
    .object()
    .transform(isFieldWithObjValueFilled)
    .test('is-valid-time', 'Invalid time format', (value) => !!value)
    .nullable();

const prepareFormForSend = (data) => {
  return Object.keys(data).reduce((result, key) => {
    const value = data[key];

    if (typeof value === 'object' && value !== null && 'value' in value) {
      result[key] = value.value;
    } else {
      result[key] = value;
    }

    return result;
  }, {});
};

export {
  prepareSelectField,
  isFieldWithObjValueFilled,
  normalizeTextFieldValue,
  prepareFormForSend,
  validateTimeFormat,
};
